/**
 * Cartwright 2026 modification — Light Works overlay toggle + focus trap
 * Manages open/close, focus trapping, Escape key, and body scroll lock.
 * Uses inline style overrides to ensure visibility works even if CSS hasn't loaded.
 */
(function () {
  'use strict';

  var overlay = document.getElementById('lightworks-overlay');
  var toggleBtn = document.getElementById('lightworks-toggle');
  if (!overlay || !toggleBtn) return;

  var scrim = overlay.querySelector('.lightworks-overlay__scrim');
  var focusableEls = [];
  var firstFocusable = null;
  var lastFocusable = null;

  function updateFocusableElements() {
    focusableEls = Array.from(
      overlay.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
    firstFocusable = focusableEls[0] || null;
    lastFocusable = focusableEls[focusableEls.length - 1] || null;
  }

  function open() {
    overlay.classList.add('is-open');
    // Override inline styles to make visible
    overlay.style.visibility = 'visible';
    overlay.style.opacity = '1';
    overlay.style.transitionDelay = '0s';
    overlay.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.querySelectorAll('.lightworks-toggle-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('lightworks-open');
    updateFocusableElements();
    if (firstFocusable) {
      requestAnimationFrame(function () {
        firstFocusable.focus({ preventScroll: true });
      });
    }
    document.addEventListener('keydown', handleKeydown);
  }

  function close() {
    overlay.classList.remove('is-open');
    // Animate out then hide
    overlay.style.opacity = '0';
    overlay.style.transitionDelay = '';
    setTimeout(function () {
      overlay.style.visibility = 'hidden';
    }, 400);
    overlay.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.querySelectorAll('.lightworks-toggle-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('lightworks-open');
    document.removeEventListener('keydown', handleKeydown);
    toggleBtn.focus({ preventScroll: true });
  }

  function toggle() {
    var isOpen = overlay.classList.contains('is-open');
    isOpen ? close() : open();
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      updateFocusableElements();
      if (focusableEls.length === 0) {
        e.preventDefault();
        return;
      }
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  }

  toggleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    toggle();
  });

  // Also bind any .lightworks-toggle-btn elements (e.g. LIGHT WORKS text link)
  document.querySelectorAll('.lightworks-toggle-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
  });

  /* Close when clicking the overlay background or scrim (anywhere outside nav links) */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target === scrim) {
      close();
    }
  });

  overlay.querySelectorAll('.lightworks-overlay__link').forEach(function (link) {
    link.addEventListener('click', function () {
      setTimeout(close, 50);
    });
  });
})();
